import {langData} from '@/utils/constants'
import { editInternational } from '@/service/standard'
export default {
  data() {
    return {
      langData: langData,
      langRules: {
        'language.ENG': [
          {
            message: 'Please typing in ENG',
            required: true
          }
        ]
      },
      libraryType: 2,
      langDialogData: {
        title: 'Langauge Detail',
        show: false,
        clickModal: false,
        data: {},
        id: '',
        loading: false
      }
    }
  },
  methods: {
    languageStort(res) {
      let list = []
      let Values = Object.values(res)
      Object.keys(res).forEach((e, index) => {
        list.push({
          key: e,
          value: Values[index]
        })
      })
      list.sort(function(a, b) {
        var enumeration = ['ENG', 'ZHO', 'CMN', 'JPN', 'KOR', 'SPA']
        return enumeration.indexOf(a.key) - enumeration.indexOf(b.key)
      })
      return list
    },
    hideLangDialog() {
      this.langDialogData.show = false
    },
    showLangaugeDetail(id) {
      if(this.getLangaugeDetail) {  
        this.getLangaugeDetail({ id: id || -1 }).then(res => {
          if (res.code === 0) {
            if(!res.data.records){
              return this.$message.error('No data')
            }
            const data = res.data.records[0]
            this.langDialogData = {
              ...this.langDialogData,
              show: true,
              loading: true,
              data: data.language,
              id: data.id,
              nameCode: data.nameCode,
              remark: data.remark
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    editLanguage(libraryType) {
      editInternational({
        libraryType: libraryType,
        language: this.langDialogData.data,
        json: JSON.stringify(this.langDialogData.data),
        remark: this.langDialogData.remark,
        id: this.langDialogData.id,
        nameCode: this.langDialogData.nameCode
      }).then(res => {
        if (res.code === 0) {
          this.hideLangDialog()
          this.$message({
            message: 'success',
            type: 'success'
          })
          this.getList && this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}